var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83329 30C1.36107 30 0.965237 29.8403 0.645793 29.5208C0.326348 29.2014 0.166626 28.8056 0.166626 28.3333C0.166626 27.8611 0.326348 27.4653 0.645793 27.1458C0.965237 26.8264 1.36107 26.6667 1.83329 26.6667H35.1666C35.6389 26.6667 36.0347 26.8264 36.3541 27.1458C36.6736 27.4653 36.8333 27.8611 36.8333 28.3333C36.8333 28.8056 36.6736 29.2014 36.3541 29.5208C36.0347 29.8403 35.6389 30 35.1666 30H1.83329ZM5.16663 25C4.24996 25 3.46524 24.6736 2.81246 24.0208C2.15968 23.3681 1.83329 22.5833 1.83329 21.6667V3.33333C1.83329 2.41667 2.15968 1.63194 2.81246 0.979167C3.46524 0.326389 4.24996 0 5.16663 0H31.8333C32.75 0 33.5347 0.326389 34.1875 0.979167C34.8402 1.63194 35.1666 2.41667 35.1666 3.33333V21.6667C35.1666 22.5833 34.8402 23.3681 34.1875 24.0208C33.5347 24.6736 32.75 25 31.8333 25H5.16663Z",
    fill: "#C80000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.b0c72df2.svg";
export { ForwardRef as ReactComponent };